<div class="form-group-container-outter">
  <div class="custom-container d-flex justify-content-between">
    @if (!showEditHeader) {
    <h4>
      {{variables.createChangeCatalogGeneric}}
    </h4>
    }

    @if (showEditHeader) {
    <div class="vertical-center header-content">
      @if (showBackArrow) {
      <a class="header-link" matTooltip="{{ variables.goBack}}" matTooltipPosition="below"
        aria-label="{{ variables.goBack}}" (click)="goToPreviousStep()">
        <mat-icon class="header-icon-img">arrow_circle_left</mat-icon>

      </a>
      }
      <div class="header-text">
        <h4 class="title-container">{{isNewTechnology ? variables.createCatalog : variables.editCatalog}}:
          {{selectedName}}</h4>
      </div>
    </div>
    }
  </div>
  <mat-stepper class="back-color" linear #stepper [class.stepper-catalog-pending]="!showEditHeader">



    <!-- STEPS -->

    <mat-step [stepControl]="formGroup0" state="s0">
      <form [formGroup]="formGroup0" (ngSubmit)="onSubmit(formGroup0.value)">
        <ng-template matStepLabel>
          <div class="label-stepper">
            {{variables.technology}}
          </div>
        </ng-template>
        <div class="form-group-container">
          <app-technology (valueChange)="forwardValue($event)" #technology
            (isNewTechnologyEvent)="AddOrUpdateTechnolgy($event)" (nextStepEvent)="nextStep($event, stepper)"
            (technologyEvent)="selectTech($event)" [stepper]="stepper" [canEditCatalog]="canEditCatalog"
            [isStepperReset]="isStepperReset"></app-technology>
        </div>
      </form>
    </mat-step>

    <mat-step [stepControl]="formGroup1" state="s1">
      <form [formGroup]="formGroup1">
        <ng-template matStepLabel>
          <div class="label-stepper">
            {{variables.users}}
          </div>
        </ng-template>
        <div class="form-group-container">
          <app-users #Users [listItem]="selectedTechnology.users" [canEditCatalog]="canEditCatalog"></app-users>
        </div>
        <div class="form-group-buttons">
          <div class="ml-auto">
            <app-button typeBtn="secondary" class="mat-button-custom me-2" (click)="nextUsers(Users, stepper)"
              message="{{variables.next}}"></app-button>
            <!--@if ((authService.isAdmin() | async)) {-->
            <app-button *hasPermission="Permission.CATALOG_EDIT_CONFIG" [showWhen]="canEditCatalog" typeBtn="primary"
              class="mat-button-custom"
              (click)="saveFromSection(Users, tipoProjeto, configuration, macroActivity, catalogo, subTask, stepper)"
              message="{{variables.save1}}"></app-button>
            <!--}-->
          </div>
        </div>
      </form>
    </mat-step>

    <mat-step [stepControl]="formGroup1" state="s2">
      <form [formGroup]="formGroup1">
        <ng-template matStepLabel>
          <div class="label-stepper">
            {{variables.projectType}}
          </div>
        </ng-template>
        <div class="form-group-container">
          <app-tipo-projeto #tipoProjeto [listItem]="selectedTechnology.projectTypes"
            [canEditCatalog]="canEditCatalog"></app-tipo-projeto>
        </div>
        <div class="form-group-buttons">
          <div class="ml-auto">
            <app-button typeBtn="secondary" class="mat-button-custom me-2" (click)="goToPreviousStep(stepper)"
              message="{{variables.previous}}"></app-button>
            <app-button typeBtn="secondary" class="mat-button-custom me-2"
              (click)="nextProjectType(tipoProjeto, stepper)" message="{{variables.next}}"></app-button>
            <!--@if ((authService.isAdmin() | async)) {-->
            <app-button *hasPermission="Permission.CATALOG_EDIT_CONFIG" [showWhen]="canEditCatalog" typeBtn="primary"
              class="mat-button-custom"
              (click)="saveFromSection(Users,tipoProjeto, configuration, macroActivity, catalogo, subTask, stepper)"
              message="{{variables.save1}}"></app-button>
            <!--}-->
          </div>
        </div>
      </form>
    </mat-step>

    <mat-step [stepControl]="formGroup4" state="s3">
      <form [formGroup]="formGroup4">
        <ng-template matStepLabel>
          <div class="label-stepper">
            {{variables.configuration}}
          </div>
        </ng-template>
        <div class="form-group-container">
          <app-configuration #configuration [listItemParams]="selectedTechnology.parameters"
            [listItem]="selectedTechnology.configurations" [canEditCatalog]="canEditCatalog"
            [profiles]="profiles"></app-configuration>
        </div>
        <div class="form-group-buttons">
          <div>
            <app-button typeBtn="secondary" class="mat-button-custom me-2" (click)="goToPreviousStep(stepper)"
              message="{{variables.previous}}"></app-button>
            <app-button typeBtn="secondary" class="mat-button-custom me-2"
              (click)="nextConfiguration(configuration, stepper)" message="{{variables.next}}"></app-button>
            <!--@if ((authService.isAdmin() | async)) {-->
            <app-button *hasPermission="Permission.CATALOG_EDIT_CONFIG" [showWhen]="canEditCatalog" typeBtn="primary"
              class="mat-button-custom"
              (click)="saveFromSection(Users,tipoProjeto, configuration, macroActivity, catalogo, subTask, stepper)"
              message="{{variables.save1}}"></app-button>
            <!--}-->
          </div>
        </div>
      </form>
    </mat-step>

    <mat-step [stepControl]="formGroup5" state="s4">
      <form [formGroup]="formGroup5">
        <ng-template matStepLabel>
          <div class="label-stepper">
            {{variables.macroActivities}}
          </div>
        </ng-template>
        <div class="form-group-container">
          <app-macroactivity #macroActivity [listItem]="selectedTechnology.macroActivities"
            [canEditCatalog]="canEditCatalog" [profiles]="profiles"></app-macroactivity>
        </div>
        <div class="form-group-buttons">
          <div>
            <app-button typeBtn="secondary" class="mat-button-custom me-2" (click)="goToPreviousStep(stepper)"
              message="{{variables.previous}}"></app-button>
            <app-button typeBtn="secondary" class="mat-button-custom me-2" (click)="nextMacro(macroActivity, stepper)"
              message="{{variables.next}}"></app-button>
            <!--@if ((authService.isAdmin() | async)) {-->
            <app-button *hasPermission="Permission.CATALOG_EDIT_CONFIG" [showWhen]="canEditCatalog" typeBtn="primary"
              class="mat-button-custom"
              (click)="saveFromSection(Users,tipoProjeto, configuration, macroActivity, catalogo, subTask, stepper)"
              message="{{variables.save1}}"></app-button>
            <!--}-->
          </div>
        </div>
      </form>
    </mat-step>

    <mat-step [stepControl]="formGroup6" state="s5">
      <form [formGroup]="formGroup6">
        <ng-template matStepLabel>
          <div class="label-stepper">
            {{variables.task}}
          </div>
        </ng-template>
        <div class="form-group-container">
          <app-catalog #catalogo [listItemActions]="selectedTechnology.tasks" [canEditCatalog]="canEditCatalog"
            [profiles]="profiles"></app-catalog>
        </div>
        <div class="form-group-buttons">
          <app-button typeBtn="secondary" class="mat-button-custom me-2" (click)="goToPreviousStep(stepper)"
            message="{{variables.previous}}"></app-button>
          <app-button typeBtn="secondary" class="mat-button-custom me-2" (click)="nextAction(catalogo, stepper)"
            message="{{variables.next}}"></app-button>
          <!--@if ((authService.isAdmin() | async)) {-->
          <app-button *hasPermission="Permission.CATALOG_EDIT_CONFIG" [showWhen]="canEditCatalog" typeBtn="primary"
            class="mat-button-custom"
            (click)="saveFromSection(Users, tipoProjeto, configuration, macroActivity, catalogo, subTask, stepper)"
            message="{{variables.save1}}"></app-button>
          <!--}-->
        </div>
      </form>
    </mat-step>


    <mat-step [stepControl]="formGroup7" state="s6">
      <form [formGroup]="formGroup7">
        <ng-template matStepLabel>
          <div class="label-stepper">
            {{variables.subTask}}
          </div>
        </ng-template>
        <div class="form-group-container">
          <app-sub-tasks #subTask [listSubTasks]="selectedTechnology.subTasks"
            [canEditCatalog]="canEditCatalog"></app-sub-tasks>
        </div>
        <div class="form-group-buttons">
          <app-button typeBtn="secondary" class="mat-button-custom me-2" (click)="goToPreviousStep(stepper)"
            message="{{variables.previous}}"></app-button>
          <!--@if ((authService.isAdmin() | async)) {-->
          <app-button *hasPermission="Permission.CATALOG_EDIT_CONFIG" [showWhen]="canEditCatalog" typeBtn="primary"
            class="mat-button-custom"
            (click)="saveFromSection(Users,tipoProjeto, configuration, macroActivity, catalogo, subTask, stepper)"
            message="{{variables.save1}}"></app-button>
          <!--}-->
        </div>
      </form>
    </mat-step>


    <!-- ICONS -->

    <ng-template matStepperIcon="s0">
      <mat-icon>language</mat-icon>
    </ng-template>

    <ng-template matStepperIcon="s1">
      <mat-icon>person</mat-icon>
    </ng-template>

    <ng-template matStepperIcon="s2">
      <mat-icon>signal_cellular_alt</mat-icon>
    </ng-template>

    <ng-template matStepperIcon="s3">
      <mat-icon>report_problem</mat-icon>
    </ng-template>

    <ng-template matStepperIcon="s4">
      <mat-icon>settings</mat-icon>
    </ng-template>

    <ng-template matStepperIcon="s5">
      <mat-icon>
        integration_instructions</mat-icon>
    </ng-template>

    <ng-template matStepperIcon="s6">
      <mat-icon>
        view_list</mat-icon>
    </ng-template>

    <ng-template matStepperIcon="edit">

      @if (stepper.selectedIndex === 0) {
      <div>
        <mat-icon>language</mat-icon>
      </div>
      }
      @if (stepper.selectedIndex === 1) {
      <div>
        <mat-icon>person</mat-icon>
      </div>
      }
      @if (stepper.selectedIndex === 2) {
      <div>
        <mat-icon>signal_cellular_alt</mat-icon>
      </div>
      }
      @if (stepper.selectedIndex === 3) {
      <div>
        <mat-icon>report_problem</mat-icon>
      </div>
      }
      @if (stepper.selectedIndex === 4) {
      <div>
        <mat-icon>settings</mat-icon>
      </div>
      }
      @if (stepper.selectedIndex === 5) {
      <div>
        <mat-icon>integration_instructions</mat-icon>
      </div>
      }
      @if (stepper.selectedIndex === 6) {
      <div>
        <mat-icon>view_list</mat-icon>
      </div>
      }
    </ng-template>

  </mat-stepper>
</div>